module.exports = __webpack_public_path__ + "static/media/15-03.202d830c.png";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-03.png
// module id = 121
// module chunks = 0